import NsModalHeader from "../../../components/modal/NsModalHeader";
import {Button, Modal} from "react-bootstrap";
import Translate from "../../../components/Translate";
import React, {Fragment, useEffect, useState} from "react";
import {formattaInteroDocVeicolo} from "../../../utility/common";
import NsDataTable from "../../../components/tabelle/NsDataTable";

export default function ModalVeicoliSimili({
                                               show,
                                               handleClose,
                                               handleOk,
                                               veicoliSimili,
                                           }) {

    const [veicoli, setVeicoli] = useState(null);
    const [veicoloSel, setVeicoloSel] = useState(null);

    useEffect(() => {
        if (veicoliSimili && veicoliSimili.length > 0) {
            setVeicoli(veicoliSimili);
        } else {
            setVeicoli(null);
        }
    }, [veicoliSimili]);

    const getDettaglioVeicoloModale = (veicolo) => {
        return (
            <Fragment>
                <div className={"row"}>
                    <div className={"col-md-4"}>
                        Marca carrozzeria: <strong>{veicolo.marca_carrozzeria || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Tipo carrozzeria: <strong>{veicolo.tipo_carrozzeria || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Tempi: <strong>{veicolo.tempi || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Potenza massima (kw o
                        CV): <strong>{formattaInteroDocVeicolo(veicolo.potenza)
                        + (veicolo.um_potenza ? (veicolo.um_potenza == '1' ? ' CV' : 'kw') : '')}</strong> a <strong>{formattaInteroDocVeicolo(veicolo.potenza_giri_motore)}</strong> g/m
                    </div>

                    <div className={"col-md-4"}>
                        Cilindri: <strong>{veicolo.cilindri || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Velocità: <strong>{veicolo.velocita || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Massa: <strong>{veicolo.massa || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Tipo cambio: <strong>{veicolo.tipo_cambio || '-'}</strong>
                    </div>

                    <div className={"col-md-4"}>
                        Lunghezza: <strong>{veicolo.lunghezza || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Larghezza: <strong>{veicolo.larghezza || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Altezza: <strong>{veicolo.altezza || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Numero porte: <strong>{veicolo.num_porte || '-'}</strong>
                    </div>

                    <div className={"col-md-4"}>
                        Misura pneumatici anteriori: <strong>{veicolo.misura_pneumatici_ant || '-'}</strong>
                    </div>
                    <div className={"col-md-4"}>
                        Misura pneumatici posteriori: <strong>{veicolo.misura_pneumatici_post || '-'}</strong>
                    </div>
                </div>
            </Fragment>
        )
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={'xl'}
        >
            <NsModalHeader title={"Veicoli simili"}/>
            <Modal.Body>
                {
                    veicoli ? (
                            <NsDataTable
                                data={veicoli}
                                columns={[
                                    {
                                        name: 'Marca',
                                        selector: row => row.marca,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Tipo',
                                        selector: row => row.tipo,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Tipo motore',
                                        selector: row => row.tipo_motore,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Tipo veicolo',
                                        selector: row => row.tipo_veicolo,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Categoria',
                                        selector: row => row.categoria,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Anno',
                                        selector: row => row.anno,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Alimentazione',
                                        selector: row => row.alimentazione,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Cilindrata',
                                        selector: row => row.cilindrata,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Cavalli',
                                        selector: row => row.cavalli,
                                        sortable: true,
                                    },
                                    {
                                        name: '',
                                        selector: row => (
                                            <Fragment>
                                                <button
                                                    type={"button"}
                                                    className={`btn btn-sm btn-${veicoloSel && row.id_veicolo === veicoloSel.id_veicolo ? 'danger' : 'dark'}`}
                                                    onClick={() => {
                                                        setVeicoloSel(row);
                                                    }}
                                                >
                                                    <i className="fas fa-check"/>
                                                </button>
                                            </Fragment>
                                        ),
                                        sortable: false,
                                        right: true,
                                    }
                                ]}
                                addPagination={true}
                                addFiltri={true}
                                addDetail={true}
                                getDettaglio={getDettaglioVeicoloModale}
                                funzioneFiltro={(item, filtro) => {
                                    return (item.tipo_motore && item.tipo_motore?.toLowerCase().includes(filtro.toLowerCase()))
                                        || (item.marca && item.marca?.toLowerCase().includes(filtro.toLowerCase()))
                                        || (item.tipo && item.tipo?.toLowerCase().includes(filtro.toLowerCase()))
                                        || (item.tipo_veicolo && item.tipo_veicolo?.toLowerCase().includes(filtro.toLowerCase()))
                                        || (item.categoria && item.categoria?.toLowerCase().includes(filtro.toLowerCase()))
                                        || (item.anno && item.anno?.toLowerCase().includes(filtro.toLowerCase()))
                                        || (item.alimentazione && item.alimentazione?.toLowerCase().includes(filtro.toLowerCase()))
                                        || (item.cilindrata && item.cilindrata?.toString().includes(filtro.toLowerCase()))
                                        || (item.cavalli && item.cavalli?.toString().includes(filtro.toLowerCase()))
                                }}
                            />
                        )
                        : <h4>Non sono stati trovati veicoli corrispondenti, in fase di richiesta certificato si dovrà
                            procedere con la compilazione manuale dei dati.</h4>
                }
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <Translate>Annulla</Translate>
                </Button>
                <Button variant="primary" onClick={() => {
                    handleOk(veicoloSel)
                }} disabled={!veicoloSel}>
                    <Translate>Conferma</Translate>
                </Button>
            </Modal.Footer>
        </Modal>
    );

}